import { Component, Input, OnChanges } from '@angular/core';
import { LeaseRecordType } from '@business-rules/lease/lease-record-type.helper';
import { getIconForLeaseRecordType } from '@shared/components/lease-record-type/lease-record-type.helper';

@Component({
  selector: 'miq-lease-record-type',
  templateUrl: 'lease-record-type.component.html',
  styleUrls: ['lease-record-type.component.scss'],
  standalone: false,
})
export class LeaseRecordTypeComponent implements OnChanges {
  @Input() public leaseRecordTypeDesc: LeaseRecordType;
  svgIconName: string;

  constructor() {}

  ngOnChanges() {
    this.svgIconName = getIconForLeaseRecordType(this.leaseRecordTypeDesc);
  }
}
